import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useStaticSelect } from "src/hooks/form/useSelect";
import { useReduxState } from "src/hooks/useRedux";

const useValidVolumeUnit = <T>(props: useFieldProps<T>) => {
	const field = useStaticSelect<ReturnType<typeof getOptions>, T>(props);
	const validWeightUnits: string[] = useReduxState(
    ["masterData", "execution", "validVolumeUnits"]
  ).value;


  React.useEffect(() => {
    field.setOptionsData(getOptions(), (data) => {
      return data || [];
    });
  }, []);

  const getOptions = () => {
    return validWeightUnits.map(el => ({ key: el, label: el }));
  };

  return field;
};

export default useValidVolumeUnit;
